<script setup lang="ts">
/** Aventross AGM (Audited) — 원본 합본 문서 2부((Incorporated In Singapore)). gen_vue 로 템플릿 글자 그대로 생성. */
import CddVarField from '../../../aura/agm/cdd/CddVarField.vue';
import DocScope from '../../../aura/agm/cdd/DocScope.vue';
import AgmSigners from '../../../aura/agm/cdd/AgmSigners.vue';
import { useRepeat } from '../useRepeat';
import '../../../aura/agm/docs/agmDoc.css';
import '../avDoc.css';

const R = useRepeat();
void CddVarField; void DocScope; void AgmSigners;
</script>

<template>
  <div class="agm-doc av-doc">
    <p class="doc-p center bold"><CddVarField field-key="company_name" label="Company Name" /></p>
    <p class="doc-p center">(Incorporated In Singapore)</p>
    <p class="doc-p center">Company Registration No. <CddVarField field-key="company_registration_no" label="Company Registration No." /></p>
    <p class="doc-p center">Registered Office:</p>
    <p class="doc-p center"><CddVarField field-key="registered_office_address" label="Registered office address" /></p>
    <div class="gap" />
    <p class="doc-p center bold">NOTICE OF ANNUAL GENERAL MEETING</p>
    <div class="gap" />
    <p class="doc-p">NOTICE IS HEREBY GIVEN that the annual general meeting of the Company will be held on <CddVarField field-key="agm_date" label="AGM date" /> at 10 a.m. at <CddVarField field-key="agm_venue" label="AGM venue" />.</p>
    <div class="gap" />
    <p class="doc-p center bold">AGENDA</p>
    <div class="gap" />
    <p class="doc-p">To receive and adopt the audited financial statements of the Company for financial year ended <CddVarField field-key="financial_year_end" label="FYE" /> together with the directors’ statement thereon.</p>
    <div class="gap" />
    <p class="doc-p">Resolved that Directors’ Remuneration and/or Benefit-in-kind (if any) as shown in the audited Financial Statements for the year ended <CddVarField field-key="financial_year_end" label="FYE" /> and paid to Director(s) be and is/are hereby approved.</p>
    <p class="doc-p">To approve the payment of Directors’ Fees of <CddVarField field-key="directors_fees" label="Directors’ fees" /> for financial year ended <CddVarField field-key="financial_year_end" label="FYE" />.</p>
    <div class="gap" />
    <p class="doc-p">To propose and declare a final one-tier tax exempt dividend of <CddVarField field-key="final_dividend" label="Final dividend per share" /> per ordinary shares for financial year ended <CddVarField field-key="financial_year_end" label="FYE" />.</p>
    <div class="gap" />
    <p class="doc-p">To note the interim one-tier tax-exempt dividend of <CddVarField field-key="interim_dividend_amount" label="Interim dividend (e.g. S$ 200,000.00)" /> (<CddVarField field-key="interim_dividend_per_share" label="Interim dividend per share (e.g. S$0.20)" /> per ordinary share) paid in respect of the financial year ended <CddVarField field-key="interim_dividend_fye" label="Interim dividend FYE" /></p>
    <div class="gap" />
    <p class="doc-p">To approve the following related party transactions: -</p>
    <div class="gap" />
    <p class="doc-p">To re-appoint, <CddVarField field-key="auditor_name" label="Auditor" /> (UEN No.: <CddVarField field-key="auditor_uen" label="Auditor UEN" />) as the Company’s Auditor and to authorize the Director to their remuneration.</p>
    <div class="gap" />
    <p class="doc-p">To re-elect retiring director(s).</p>
    <div class="gap" />
    <p class="doc-p">To transact any other ordinary business which may properly be transacted at the Annual General Meeting.</p>
    <div class="gap" />
    <p class="doc-p">By Order Of The Board</p>
    <div class="gap" />
    <p class="doc-p">_________________________</p>
    <p class="doc-p"><CddVarField field-key="notice_director_name" label="Director (notice)" /></p>
    <p class="doc-p">Director</p>
    <div class="gap" />
    <p class="doc-p bold">Singapore, <CddVarField field-key="agm_date" label="AGM date" /></p>
    <div class="gap" />
    <p class="doc-p bold">Proxies:</p>
    <div class="gap" />
    <p class="doc-p">A member entitled to attend and vote at the above meeting is entitled to appoint a proxy to attend and vote instead of him.  A proxy need not be a member of the Company.  The instrument appointing a proxy must be deposited at the registered office of the Company not less than 48 hours before the meeting.</p>
    <div class="gap" />
    <p class="doc-p">A corporation which is a member of the Company may, by resolution of its directors, authorise any person to act as its representative at any meetings of the Company, and such representative shall be entitled to exercise the same powers on behalf of the corporation which he represents as if he had been an individual member of the Company. </p>
  </div>
</template>
